import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModeComponent } from './shared/components/header/widgets/mode/mode.component'
import { isDevMode } from '@angular/core';
import { environment } from '@/environments/environment';
import { ConfigurationV2Service } from './shared/services/configuration-v2.service';
import { TrackingService } from './shared/services/tracking.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'ecrms-admin-angular';
  private modeComponent: ModeComponent;
  constructor(private translateService: TranslateService, private configV2: ConfigurationV2Service, private tracking: TrackingService) {
    this.translateService.setDefaultLang('en');
    this.translateService.use('en');
  }

  ngOnInit(): void {
    // Chính sách ghi hành vi nhân viên (bật/tắt, từng loại event, chia mẫu) lấy từ ConfigurationV2 một lần khi mở admin. Lỗi hoặc chưa có config thì tắt.
    const et: any = (environment as any).eventTracking;
    if (et?.enabled && et?.configName) {
      this.configV2.getConfigurations(JSON.stringify({ configNames: [et.configName] })).subscribe({
        next: (res: any) => this.tracking.applyPolicy(res?.[0]?.configJsonValue ?? null),
        error: () => this.tracking.applyPolicy(null),
      });
    }
    if (this.isDevelopmentMode()) {
      // document.body.classList.toggle('dark-only');
    } else {

    }
  }

  
  isDevelopmentMode(): boolean {
    return !environment.production && isDevMode();
  }
}

